"use client";

import { SignInFormVariant, SignInVariant } from "./SignInSignUpForm";

import { GoogleIcon } from "../common/icons";
import SignInButton from "./SignInButton";

interface Props {
  name: string;
  value: SignInVariant;
  variant?: SignInFormVariant;
  className?: string;
}

export default function GoogleSignInButton({
  name,
  value,
  variant = "normal",
  className,
}: Props) {
  return (
    <SignInButton
      name={name}
      value={value}
      variant={variant}
      label="Sign in with Google"
      Icon={GoogleIcon}
      className={className}
    />
  );
}
